import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useUser, UserButton } from '@clerk/clerk-react';
import { useUnifiedWallet } from '../contexts/UnifiedWalletContext';
import { chainConfig } from '../config/chains';
import floobizMark from '../assets/floobiz-mark.jpg';
import './Header.css';

const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Floobiz';

function Header() {
  const navigate = useNavigate();
  const { user } = useUser();
  const { isConnected, currentWallet, connectWallet, disconnectWallet, formatAddress } = useUnifiedWallet();
  const bsc = chainConfig('bsc');

  return (
    <header className="app-header">
      <div
        className="app-header__brand"
        onClick={() => navigate('/admin')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/admin')}
      >
        <img src={floobizMark} alt={SITE_NAME} className="app-header__logo" />
        <span className="app-header__name">{SITE_NAME}</span>
        <span className="app-header__chain-pill">{bsc.name}</span>
      </div>

      <nav className="app-header__nav">
        <NavLink to="/admin" end>Admin</NavLink>
        <NavLink to="/deploy">Deploy token</NavLink>
        <NavLink to="/admin/presale">Presale settings</NavLink>
        <NavLink to="/contracts">Contracts</NavLink>
        <NavLink to="/admin/transactions">Transactions</NavLink>
        <NavLink to="/buy">Buy page ↗</NavLink>
      </nav>

      <div className="app-header__right">
        {isConnected ? (
          <button className="wallet-pill" onClick={disconnectWallet}>
            {formatAddress(currentWallet?.account)} · Disconnect
          </button>
        ) : (
          <button className="connect-btn" onClick={connectWallet}>Connect wallet</button>
        )}
        {user && <UserButton afterSignOutUrl="/" />}
      </div>
    </header>
  );
}

export default Header;
